import React from 'react';
import './Background.css';
const Background = (props: any) => {
    return (
        <div className='bik-sm-background' id='bik-background'>
            {props.children}
        </div>
    )
}
export default Background